import { Link } from '@tanstack/react-router'
import { ChevronDown } from 'lucide-react'
import { useState } from 'react'
import { cn } from '@/lib/utils'

export interface CollectionSectionItem {
  id: string
  label: string
  icon: string | null
}

interface Props {
  label: string
  items: CollectionSectionItem[]
  activeId?: string
  fallbackIcon?: React.ReactNode
}

export function CollectionSectionBlock({ label, items, activeId, fallbackIcon }: Props) {
  const [open, setOpen] = useState(true)
  return (
    <div>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center gap-1 px-3 py-1 text-[11px] font-semibold uppercase tracking-wider text-muted-foreground hover:text-foreground"
      >
        <ChevronDown className={cn('h-3.5 w-3.5 transition-transform', !open && '-rotate-90')} />
        {label}
      </button>
      {open ? (
        <ul className="mt-1 space-y-1">
          {items.map((it) => {
            const active = activeId === it.id
            return (
              <li key={it.id}>
                <Link
                  to="/groups/$groupId"
                  params={{ groupId: it.id }}
                  className={cn(
                    'flex w-full items-center gap-2 rounded-full px-2 py-1.5 text-sm transition-colors',
                    active ? 'bg-primary text-primary-foreground' : 'text-foreground hover:bg-surface-soft',
                  )}
                >
                  <span
                    className={cn(
                      'flex h-[34px] w-[34px] shrink-0 items-center justify-center rounded-[17px] text-base leading-none',
                      active ? 'bg-white/20 text-primary-foreground' : 'bg-surface-soft text-foreground',
                    )}
                  >
                    {it.icon ?? fallbackIcon ?? '•'}
                  </span>
                  <span className="flex-1 truncate font-medium">{it.label}</span>
                </Link>
              </li>
            )
          })}
        </ul>
      ) : null}
    </div>
  )
}
